import React from 'react';

const Optional: React.FC = () => {
  return <span className="text-gray-500">(optional)</span>;
};

export default Optional;
